document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const moneyText = (value) => value;

const policyHashPattern = /^#policy-(privacy|shipping|about|contact|payment|terms|returns)$/;

const clearPolicyHash = () => {
  if (!policyHashPattern.test(window.location.hash)) return;
  history.replaceState({}, '', `${window.location.pathname}${window.location.search}`);
};

const closePolicyDialog = (dialog, restoreFocus = true) => {
  if (!dialog) return;
  if (typeof dialog.close === 'function' && dialog.open) dialog.close();
  else dialog.removeAttribute('open');
  document.body.classList.remove('policy-dialog-open');
  clearPolicyHash();
  if (restoreFocus) dialog.policyOpener?.focus?.();
};

const openPolicyDialog = (hash, opener) => {
  if (!policyHashPattern.test(hash)) return false;
  const dialog = document.querySelector(hash);
  if (!dialog || dialog.tagName !== 'DIALOG') return false;

  document.querySelectorAll('.policy-dialog[open]').forEach((openDialog) => {
    if (openDialog !== dialog) closePolicyDialog(openDialog, false);
  });

  dialog.policyOpener = opener || document.activeElement;
  if (!dialog.open) {
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }
  document.body.classList.add('policy-dialog-open');
  history.replaceState({}, '', `${window.location.pathname}${window.location.search}${hash}`);
  dialog.querySelector('[data-policy-close]')?.focus();
  return true;
};

document.addEventListener('click', (event) => {
  const policyLink = event.target.closest('a[href^="#policy-"]');
  if (policyLink && openPolicyDialog(policyLink.getAttribute('href'), policyLink)) {
    event.preventDefault();
    return;
  }

  const policyClose = event.target.closest('[data-policy-close]');
  if (policyClose) {
    closePolicyDialog(policyClose.closest('.policy-dialog'));
    return;
  }

  const quantityButton = event.target.closest('[data-quantity-change]');
  if (quantityButton) {
    const wrapper = quantityButton.closest('[data-quantity]');
    const input = wrapper?.querySelector('input[type="number"]');
    if (!input) return;
    const delta = Number(quantityButton.dataset.quantityChange || 0);
    const min = Number(input.min || 1);
    input.value = Math.max(min, Number(input.value || min) + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const mobileLink = event.target.closest('.mobile-nav a');
  if (mobileLink) mobileLink.closest('details')?.removeAttribute('open');
});

document.querySelectorAll('.policy-dialog').forEach((dialog) => {
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closePolicyDialog(dialog);
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closePolicyDialog(dialog);
  });
});

if (policyHashPattern.test(window.location.hash)) {
  openPolicyDialog(window.location.hash, null);
}

document.addEventListener('change', async (event) => {
  const input = event.target.closest('[data-option-value-id], [data-option-value-select]');
  if (!input) return;

  const productSection = input.closest('[data-product-section]');
  const picker = input.closest('[data-option-picker]');
  if (!productSection || !picker) return;

  const selectedIds = [
    ...picker.querySelectorAll('[data-option-value-id]:checked'),
    ...picker.querySelectorAll('[data-option-value-select]')
  ]
    .map((item) => item.dataset.optionValueId || item.value)
    .filter(Boolean);
  const sectionId = productSection.dataset.sectionId;
  const selectedOption = input.matches('select') ? input.options[input.selectedIndex] : input;
  const baseUrl = selectedOption.dataset.productUrl || productSection.dataset.productUrl || window.location.pathname;
  const query = selectedIds.length ? `&option_values=${selectedIds.join(',')}` : '';
  const focusKey = input.dataset.focusKey;

  productSection.classList.add('is-loading');
  try {
    const response = await fetch(`${baseUrl}?section_id=${sectionId}${query}`);
    if (!response.ok) throw new Error('Unable to load variant');
    const markup = await response.text();
    const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
    const replacement = documentFragment.querySelector('[data-product-section]');
    if (!replacement) throw new Error('Variant section missing');
    productSection.replaceWith(replacement);
    const publicQuery = selectedIds.length ? `?option_values=${selectedIds.join(',')}` : '';
    history.replaceState({}, '', `${baseUrl}${publicQuery}`);
    replacement.querySelector(`[data-focus-key="${CSS.escape(focusKey)}"]`)?.focus();
  } catch (error) {
    productSection.classList.remove('is-loading');
  }
});

const loadRecommendations = async (element) => {
  const url = element.dataset.url;
  if (!url || element.dataset.loaded === 'true') return;
  element.dataset.loaded = 'true';
  try {
    const response = await fetch(url);
    if (!response.ok) return;
    const text = await response.text();
    const parsed = new DOMParser().parseFromString(text, 'text/html');
    const replacement = parsed.querySelector('product-recommendations');
    if (replacement?.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
  } catch (error) {
    // Recommendations are optional; leave the page usable if they fail.
  }
};

const recommendationObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    loadRecommendations(entry.target);
    observer.unobserve(entry.target);
  });
}, { rootMargin: '300px 0px' });

document.querySelectorAll('product-recommendations').forEach((element) => recommendationObserver.observe(element));
